import React from 'react';

import styles from './AxisScaleFields.module.css';

export default function({ title, values, onValueChange }) {
  if (!values) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.fieldsContainer}>
        {values.map((value, fieldIndex) => (
          // eslint-disable-next-line react/no-array-index-key -- the position on the scale is what identifies a field
          <div className={styles.fieldRow} key={fieldIndex}>
            <span className={styles.fieldRowNumber}>{fieldIndex + 1}</span>
            <input
              className={styles.field}
              value={value}
              onChange={e => onValueChange(fieldIndex, e.target.value)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
